import { ReactNode } from 'react';
import { CircleHelp } from 'lucide-react';

interface CardProps {
    children: ReactNode;
    className?: string;
    onClick?: () => void;
    showTutorial?: boolean;
    hideTutorialIcon?: boolean;
    tutorial?: string;
    tutorialAlign?: 'center' | 'top';
}

export const Card = ({ children, className = '', onClick, tutorial, showTutorial, hideTutorialIcon = false, tutorialAlign = 'center' }: CardProps) => {
    const isClickable = !!onClick;

    return (
        <div
            onClick={onClick}
            className={`
                bg-white rounded-[32px] border border-slate-100 shadow-[0_8px_30px_rgba(0,0,0,0.04)]
                transition-all duration-300 relative
                ${isClickable ? 'cursor-pointer hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)] group' : ''}
                ${className}
            `}
        >
            {/* Tutorial Overlay */}
            {showTutorial && tutorial && (
                <div className={`
                    absolute inset-0 bg-violet-900/90 z-50 rounded-[32px] flex justify-center py-6 px-4 text-center animate-fade-in backdrop-blur-sm
                    ${tutorialAlign === 'top' ? 'items-start pt-32' : 'items-center'}
                `}>
                    <div className="text-white w-full max-h-full overflow-y-auto scrollbar-thin scrollbar-thumb-violet-400 scrollbar-track-transparent px-2">
                        {!hideTutorialIcon && <CircleHelp className="w-8 h-8 mx-auto mb-3 text-violet-300 sticky top-0 bg-violet-900/0" />}
                        <p className="text-sm font-medium leading-relaxed whitespace-pre-line">{tutorial}</p>
                    </div>
                </div>
            )}
            {children}
        </div>
    );
};
